import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

export function usePageTitle() {
  const { t } = useTranslation();
  const location = useLocation();

  useEffect(() => {
    const baseTitle = 'Kaizen Network';
    let pageTitle = `${baseTitle} - Minecraft Server Indonesia`;

    // Remove language prefix for path matching
    const pathWithoutLang = location.pathname.replace(/^\/(en|id)/, '');

    switch (pathWithoutLang) {
      case '':
        pageTitle = `${baseTitle} - Minecraft Server Indonesia | Play Survival & Minigames`;
        break;
      case '/leaderboard':
        pageTitle = `${t('nav.leaderboard')} - Top Players | ${baseTitle}`;
        break;
      case '/vote':
        pageTitle = `${t('navbar.vote')} - Support Our Server | ${baseTitle}`;
        break;
      default:
        if (location.pathname === '/404' || !pathWithoutLang.match(/^(\/[a-zA-Z0-9-_]*)?$/)) {
          pageTitle = `Page Not Found | ${baseTitle}`;
        }
        break;
    }

    document.title = pageTitle;

    // Update Open Graph and Twitter title tags dynamically
    document.querySelector('meta[property="og:title"]')?.setAttribute('content', pageTitle);
    document.querySelector('meta[property="twitter:title"]')?.setAttribute('content', pageTitle);
  }, [location.pathname, t]);
} 